// Entry point for the lite web UI. Polyfills are injected per-usage by Babel
// (see babel.config.js / .browserslistrc) rather than imported wholesale here.
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app.jsx';

// Mount into the server-rendered <div data-react-class="App"> (see
// app/views/index/index.html.erb). That div carries a crawlable skeleton, so
// we can't use webpacker-react's mounter, which only mounts into empty nodes.
function mount() {
  const node = document.querySelector('[data-react-class="App"]');
  if (!node) return;
  const props = JSON.parse(node.getAttribute('data-react-props') || '{}');
  ReactDOM.render(React.createElement(App, props), node);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
